export default "__VITE_ASSET__DT2UHBBV__"